import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';

export interface ISetSiteSAMLAllowEmbeddedAuthenticationParams {
  allow: boolean;
}

export class SetSiteSAMLAllowEmbeddedAuthenticationRequest extends Request<ISetSiteSAMLAllowEmbeddedAuthenticationParams, ISiteSAMLConfiguration> {
  constructor(params: ISetSiteSAMLAllowEmbeddedAuthenticationParams) {
    super('setSiteSAMLAllowEmbeddedAuthentication', params);
  }
}
